import React from "react";

import Checkbox from "@material-ui/core/Checkbox";
import PropTypes from "prop-types";

import useRbCheckboxStyles from "./useRbCheckboxStyles";

export const RbCheckbox = React.forwardRef(function RbCheckbox(props, ref) {
  const { onChange, onChangeChecked, ...other } = props;

  const classes = useRbCheckboxStyles(props);

  const handleChange = React.useCallback(
    (event) => {
      if (onChange) {
        onChange(event);
      }
      if (onChangeChecked) {
        onChangeChecked(event.target.checked);
      }
    },
    [onChange, onChangeChecked]
  );

  return (
    <Checkbox {...other} classes={classes} ref={ref} onChange={handleChange} />
  );
});

RbCheckbox.propTypes = {
  onChange: PropTypes.func,
  onChangeChecked: PropTypes.func,
};

RbCheckbox.defaultProps = {
  onChange: undefined,
  onChangeChecked: undefined,
};

RbCheckbox.displayName = "RbCheckbox";

export default React.memo(RbCheckbox);
